import './Footer.css';

function Footer() {
  return (
    <div className="footer">
      <h2>@pilkajestokragla.pl</h2>
    </div>
  );
}

export default Footer;
